<script>
import { reactive } from 'vue';
import { ArrowDown, ArrowRight } from '@element-plus/icons-vue';

export default {
  name: "Home",
  setup() {
    const sections = reactive([
      { visible: true },
      { visible: true },
      { visible: true },
      { visible: true },
      { visible: true },
      { visible: true },
      { visible: true },
      { visible: true },
      { visible: true },
      { visible: true },
      { visible: true }
    ]);

    const toggleSection = (index) => {
      sections[index].visible = !sections[index].visible;
    };

    return {
      sections,
      toggleSection,
      ArrowDown,
      ArrowRight
    };
  }
}
</script>

<template>
  <div class="conference-details">
    <h1 @click="toggleSection(0)">About Conference<el-icon style="float:right"><component :is="sections[0].visible ? ArrowDown : ArrowRight" /></el-icon></h1>
    <div v-show="sections[0].visible">
        <p>
            Focusing on the genetic and functional diversity of tropical plants, especially research themes related to the biology of tropical crops, this conference intends to invite the world's leading experts in the field of tropical plants and crop biology to discuss research on tropical plants in the era of artificial intelligence, establish a development framework, and lead the direction of resource input and development in the fields of genetic resources, nutrient active substances and data mining, product creation and survival environment optimization, expand the thousands of tropical plant genomes project, and give full play to the function of Tropical Plants journals in carrying and disseminating information.
        </p>
    
    </div>

    <h1 @click="toggleSection(1)">Key Dates and Place<el-icon style="float:right"><component :is="sections[1].visible ? ArrowDown : ArrowRight" /></el-icon></h1>
    <div v-show="sections[1].visible">
        <ul>
            <li>Time: March 23-25, 2026</li>
            <li>Place: The Zign hotel, Pattaya Chonburi, Thailand</li> 
        </ul>
    </div>

    <h1 @click="toggleSection(2)">Session Themes<el-icon style="float:right"><component :is="sections[2].visible ? ArrowDown : ArrowRight" /></el-icon></h1>
    <div v-show="sections[2].visible">
      <ul>
        <li>
          <b>Climate Change Impacts and Adaptive Strategies for Tropical Agriculture</b>
          <br>
          <p>Focus: Understanding how climate change affects tropical farming systems and exploring practical strategies for adaptation.</p>
        </li>
        <li>
          <b>Physiological and Molecular Mechanisms of Stress Tolerance in Tropical Plants</b>
          <br>
          <p>Focus: Delving into the fundamental biological processes and genetic underpinnings that enable tropical plants to withstand environmental stresses.</p>
        </li>
        <li>
          <b>Advanced Breeding and Biotechnology for Climate-Resilient Tropical Crops</b>
          <br>
          <p>Focus: Showcasing cutting-edge approaches in plant breeding and biotechnology to develop new, robust crop varieties.</p>
        </li>
        <li>
          <b>Smart Agriculture, Forestry, & Plant Protection in Tropical Regions </b>
          <br>
          <p>Focus: Exploring modern agricultural technologies, sustainable forestry practices, and effective plant disease/pest management for tropical environments.</p>
        </li>
        <li>
          <b>Discovery and Characterization of Novel Bioactive Compounds from Tropical Plants</b>
          <br>
          <p>Focus: Identifying and analyzing new health-promoting compounds found in tropical flora, and their potential applications.</p>
        </li>
        <li>
          <b>Tropical Plants in Carbon Sequestration and the Bioeconomy</b>
          <br>
          <p>Focus: Examining the role of tropical plants in mitigating climate change through carbon capture and their contribution to a sustainable, bio-based economy.</p>
        </li>
        <li>
          <b>Resilient Coconut Futures: Bridging Genetics, Smart Agriculture, and the Bioeconomy.  </b>
          <br>
         </li>
      </ul>
    </div>

    <h1 @click="toggleSection(3)">Organizations<el-icon style="float:right"><component :is="sections[3].visible ? ArrowDown : ArrowRight" /></el-icon></h1>
    <div v-show="sections[3].visible">
      <h2>Organizer:</h2>
      <ul>
        <li>Kasetsart University</li>
        <li>Hainan University</li>
        <li>National Key Laboratory of Tropical Crop Breeding</li>
        <li>International Coconut Community (ICC)</li>
      </ul>
      <h2>Co-organizer:</h2>
      <ul>
        <li>Tropical Plants</li>
        <li>Maximum Academic Press</li>
        <li>National Research Council of Thailand</li>
        <li>Ministry of Higher Education, Science, Research and Innovation</li>
        <li>The Thai Tapioca Development Institute (TTDI)</li>
        <li>Thai Tapioca Starch Association</li>
        <li>International Research Institute, Yunnan Academy of Agricultural Sciences, China</li>
      </ul>
    </div>

    <h1 @click="toggleSection(4)">Organizing Committee<el-icon style="float:right"><component :is="sections[4].visible ? ArrowDown : ArrowRight" /></el-icon></h1>
    <div v-show="sections[4].visible">
      <h2>Honorary Chairmen:</h2>
      <ul>
        <li>Dr. Damrong Sripraram, Acting President of Kasetsart University</li>
        <li>Mr. Rapibhat Chandarasrivongs, Director-General, Department of Agriculture</li>
        <li>Associate Professor Dr. Patchareeya Boonkorkaew, Dean of the Faculty of Agriculture, Kasetsart University</li>
        <li>Professor Dr. Chareinsak Rojanaridpiched, Thai Tapioca Development Institute (TTDI)</li>
        <li>Associate Professor Dr. Klanarong Sriroth, National Research Council of Thailand</li>
        <li>Zongming Cheng, CEO Maximum Academic Press, Professor, Nanjing Agriculture University</li>
        <li>Zuoyan Zhu, Academician of Chinese Academy of Sciences, Professor of aquatic sciences</li>
        <li>Ming Peng, Professor, Institute of Tropical Biosciences & Biotechnology, CATAS</li>
        <li>Hongwen Huang, Professor, director of Lushan Botanical Garden, The Chinese Academy of Sciences, China</li>
        <li>Dr. Jelfina Alouw, Director General International Coconut Community (ICC) </li>
      </ul>
      <h2>Chairmen:</h2>
      <ul>
        <li>Wanwisa Siriwan, Associate Professor of Kasetsart University, Thailand</li>
        <li>Tanapon Chaisan, Associate Professor of Kaseteart University, Thailand</li>
        <li>Jie Luo, professor, Hainan University, chief scientist Multi-omics platform of Yazhoubay Laboratory, China</li>
        <li>Wenquan Wang, professor of Hainan University, China</li>
        <li>Robert Henry, Academician of Australian Academy of Technology and Engineering, professor of University of Queensland, Australia</li>
      </ul>
      <h2>Executive Chairmen:</h2>
      <ul>
        <li>Srihunsa Malichan, Assistant Professor of Kasetsart University, Thailand</li>
        <li>Pasajee Kongsila, Associate Professor of Kasetsart University, Thailand</li>
        <li>Sarawut Pungmekarat, Assistant Professor of Kasetsart University, Thailand</li>
        <li>Songyos Chotchutima, Assistant Professor of Kasetsart University, Thailand</li>
        <li>Anuwat Kumpeangkeaw, professor, Ministry of Agriculture, Thailand</li>
        <li>Siwaret Arikit, Associate Professor of Kasetsart University, Thailand</li>
        <li>Chutchamas Kanchanaudomkarn, Assistant Professor of Kasetsart University, Thailand</li>
        <li>Peerasak Chaiprasart, Assistant Professor of Naresuan University</li>
        <li>Fei Chen, professor, Hainan University, China</li>
        <li>Zhiqiang Xia, professor, Hainan University, China</li>
        <li>Xingtan Zhang, professor of Agricultural Genomics Institute at Shenzhen, Chinese Academy of Agricultural Sciences, vice director of National Key Laboratory for Breeding of Tropical Crops</li>
      </ul>
    </div>

    <!-- <h1 @click="toggleSection(5)">Special Guests and Speakers<el-icon style="float:right"><component :is="sections[5].visible ? ArrowDown : ArrowRight" /></el-icon></h1>
    <div v-show="sections[5].visible">
      <ul>
        <li>Henry Robert, Academician, The University of Queensland, Australian Academy of Technology and Engineering</li>
        <li>Dezhu Li, Professor, Kunming Institute of Botany, Chinese Academy of Sciences</li>
        <li>Weixiong Zhang, Professor, Artificial Intelligence and Bioinformatics Experts, Hong Kong Polytechnic University</li>
        <li>Ying Wang, Professor, South China Botanical Garden, Chinese Academy of Sciences</li>
        <li>Chentao Lin, Professor, Fujian Agriculture and Forestry University - University of California, Los Angeles</li>
        <li>
          Victor Albert,  University of Buffalo
          <br>coffee origin and research on many other tropical plants
        </li>
        <li>
          Van Schelper-Luu, IRRI
          <br>diseases of rice
        </li>
        <li>
          Darren Crayn, Director Australian Tropical Herbarium
          <br>tropical plant evolution and distribution
        </li>
        <li>
          Glaucia Souza, University of Sao Paulo
          <br>sugarcane and bioenergy
        </li>
        <li>Mohammad Khalequzzaman, Director, Bangladesh Rice Research Institute (BRRI)</li>
        <li>
          Duong Thi Nguyen, Deputy Director of the Academic Affair Office, Thai Nguyen University of Agriculture and Forestry, Vietnam
          <br>New emerging pests and their environmentally friendly management for sustainable development of agriculture in Vietnam.
        </li>
        <li>Jie Luo, Professor, Hainan University, Yazhouwan National Laboratory</li>
        <li>Liangsheng Zhang, Professor, Zhejiang University</li>
        <li>Wenwu Guo, Professor, Huazhong Agricultural University</li>
        <li>Yaobin ZHANG, Professor, Yunnan Academy of Agricultural Sciences, China</li>
        <li>Yongping Yang, Professor, XiShuangBanNa Tropical Botanical Garden</li>
        <li>
          Peng Xu, Professor, XiShuangBanNa Tropical Botanical Garden
          <br>Exploration and utilization of upland rice germplasm resources in resilient rice breeding responding to climate change
        </li>
        <li>Gang Liang, XiShuangBanNa Tropical Botanical Garden</li>
        <li>
          Jianghua Chen, XiShuangBanNa Tropical Botanical Garden
          <br>Compound leaf development in legumes
        </li>
        <li>Weimin Tian,Professor, Rubber Research Center, Xishuangbanna Tropical Botanical Garden, China</li>
        <li>Xingtan Zhang, Professor, Institute of Agricultural Genomics, Chinese Academy of Agricultural Sciences, China</li>
        <li>Rui Xia, Professor, South China Agricultural University</li>
        <li>Youxiong Que, Professor, Chinese Academy of Tropical Agricultural Sciences, China</li>
        <li>Peitao Lv, Professor, Institute of Biotechnology, Chinese Academy of Tropical Agricultural Sciences, China</li>
        <li>Chaorong Tang, Professor, Hainan University</li>
        <li>Zhiqiang Xia, Professor, Hainan University</li>
        <li>Fei Chen, Professor, Hainan University</li>
        <li>Shaoying Wu, Professor, Hainan University</li>
        <li>Ke Dong, Professor, Duke University</li>
        <li>
          Hong Li, Professor, Yunnan Agricultural University (Vice President)
          <br>Current Situation and Prospect of Yunnan Coffee Industry
        </li>
        <li>
          Fusheng Li, Professor, Yunnan Agricultural University
          <br>Sugarcane Resources Research and Germplasm Innovation.
        </li>
        <li>
          Chengyun Li, Professor, Yunnan Agricultural University
          <br>Ecological management of pest and disease in trop crops
        </li>
        <li>
          Chunmei Wang, Professor, Yunnan Dehong Institute of Tropical Agricultural Science, Yunnan Province, China
          <br>Identification of the pathogen causing Paramyrotheca leaf blight on Coffee and resistance evaluation of coffee varieties(germplasms)
        </li>
      </ul>
    </div> -->

    <h1 @click="toggleSection(6)">About Hosts<el-icon style="float:right"><component :is="sections[6].visible ? ArrowDown : ArrowRight" /></el-icon></h1>
    <div v-show="sections[6].visible">
      <h2>Kasetsart University</h2>
      <p style="text-indent:2em">
        Kasetsart University (KU), established on February 2, 1943, stands as Thailand's first agricultural university and third oldest overall. While its core strength remains in agricultural sciences, consistently ranking among the top universities globally for Agriculture & Forestry, it has significantly broadened its academic scope to include diverse fields such as life sciences, engineering, social sciences, humanities, and environmental science. This comprehensive approach, combined with its strong research-oriented focus and numerous research institutes, drives impactful innovations and fosters active international collaborations with partners worldwide. Supporting this expansive academic and research mission is a substantial community. Kasetsart University boasts a large student body, with recent figures indicating approximately 69,171 students across all programs and campuses, making it one of Thailand's largest universities by enrollment. This diverse group is taught and guided by a robust academic staff of around 2,880 teaching personnel, ensuring a reasonable student-to-staff ratio for effective learning. Beyond faculty, a significant number of administrative and support staff ensure the smooth operation of the university's many faculties, institutes, and services. With multiple campuses across Thailand and a steadfast commitment to sustainable development, Kasetsart University leverages its extensive expertise and considerable human resources to address global challenges, contributing significantly to food security, environmental conservation, and overall economic and social development, solidifying its "world-class" status as a key player in global academia and research.
      </p>
      <h2>Hainan University</h2>
      <p style="text-indent:2em">
        Hainan University (HNU), headquartered in Haikou city in China, has four campuses covering an area of 4.087 million square meters. HNU has 42,000 full-time students, 31 secondary schools, 13 first-level discipline doctorate programs, 34 first-level discipline master's programs, and 69 undergraduate programs. The Agriculture and Life Science disciplines have a long history dating back to 1953 and have created outstanding achievements. Crop Science has been selected as a world-class discipline for two consecutive rounds, and eight disciplines - Plant and Animal, Chemistry, Materials, Engineering, Environment, Ecology, Biology and Biochemistry, as well as General Social Science - are ranked among the top 1% worldwide according to ESI (Essential Science Indicators). The university has more than 2,700 full-time professors and researchers, including 60 national-level researchers such as academicians, Changjiang Scholars, and China National Distinguished Young Scholars.
      </p>
      <p style="text-indent:2em">
        HNU is dedicated to serving national strategies and adhering to the overall principle of providing featured academic support, offering quality education resources, and promoting opening-up and innovation. It will make every effort to realize the mission of the new era by continuing to serve as a first-class comprehensive research-oriented university with distinctive features and an international reputation.
      </p>
      <h2>National Key Laboratory of Tropical Crop Breeding</h2>
      <p>
        The National Key Laboratory of Tropical Crop Breeding is the only national key laboratory in the field of tropical crop research in China, which is supported by the Chinese Academy of Tropical Agricultural Sciences (CATAS), Hainan University, Shenzhen Agricultural Genomics Institute of Chinese Academy of Agriculture (CAS) and Yunan Academy of Agriculture Sciences. With the purpose of strengthening the national strategic scientific and technological strength and innovating to lead the high-quality development of tropical agriculture, Hot Crop All-Heavy focuses on five key research crops, such as rubber tree, oil palm, sugarcane, banana and cassava, and carries out theoretical innovation, technological breakthroughs and new varieties cultivation of tropical crop biological breeding, to seize the commanding heights of hot crop science and technology.
      </p>
      <h2>Tropical Plants</h2>
      <p>
        Tropical Plants, including tropical crops such as rubber tree, banana, cassava, sugar cane, mango, pineapple, etc., have important economic values in tropical countries around the world, and support a huge processing industry chain. Tropical Plants is an international, open access, online-only journal publishing rigorously peer-reviewed original research papers, review articles, break-through methods, and perspectives that advance our understanding of plant growth and development and their utilization. The journal is published by Maximum Academic Press (http://www.maxapress.com).
      </p>
    </div>

    <h1 @click="toggleSection(7)">Sponsors<el-icon style="float:right"><component :is="sections[7].visible ? ArrowDown : ArrowRight" /></el-icon></h1>
    <div v-show="sections[7].visible">
      <div class="photo_box">
        <ul>
          <!-- <li class="photo_li"><a><img class="photo" src="../../assets/images/cassavahub.png" alt="Photo 1"></a></li> -->
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor1.png" alt="Photo 1"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor2.png" alt="Photo 2"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor3.png" alt="Photo 3"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor4.png" alt="Photo 4"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor5.png" alt="Photo 5"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor6.png" alt="Photo 6"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor7.png" alt="Photo 7"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor8.png" alt="Photo 8"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor9.png" alt="Photo 9"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor10.png" alt="Photo 10"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor11.png" alt="Photo 11"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor12.png" alt="Photo 12"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor13.png" alt="Photo 13"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/sponsor14.png" alt="Photo 14"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/icc.png" alt="Photo 15"></li>
          <li class="photo_li"><img class="photo" src="../../assets/images/cogent.png" alt="Photo 16"></li>
          <li class="photo_li">
            <router-link to="/sailgene">
              <img class="photo" src="../../assets/images/saigene.png" alt="Sailgene">
            </router-link>
          </li>
          <li class="photo_li">
            <router-link to="/sanshubio">
              <img class="photo" src="../../assets/images/sanshu.png" alt="SanshuBio">
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <h1 @click="toggleSection(8)">Sponsor Introduction<el-icon style="float:right"><component :is="sections[8].visible ? ArrowDown : ArrowRight" /></el-icon></h1>
    <div v-show="sections[8].visible">
      <h2><router-link class="sponsor-intro-link" to="/sailgene">Sailgene</router-link></h2>
      <p>
        Sailgene Technology (Hong Kong) Co., Ltd. is a Hong Kong-based high-tech enterprise dedicated to the advancement of nanopore sequencing, next-generation sequencing, and bioinformatics analysis. Led by a core team with extensive experience in high-throughput and nanopore sequencing technologies, the company has developed a comprehensive suite of solutions including extraction, library construction, and sequencing reagents for its nanopore platforms.
      </p>
      <p>
        These platforms are distinguished by their scalability, ranging from portable devices to high-throughput systems, and are applied across diverse fields such as human, plant, animal, microbial, and environmental genetics. Increasingly, their technology is utilized in commercial sectors like healthcare and food safety.
      </p>
      <p>
        Driven by a mission to advance multi-platform sequencing technology and commercialize research achievements, Sailgene remains at the forefront of innovation. The company's impact is evident in its key technical accomplishments: achieving ultra-long DNA sequencing with an N50 read length of 200Kb, and developing a comprehensive portfolio of RNA sequencing products, including Direct RNA Sequencing and Single-cell Full-Length Transcriptome solutions. In microbiology, they have independently developed a detection system covering all published microbial genomes. Their ultimate vision is to apply technology and responsibility to serve human health and drive scientific progress.
      </p>

      <h2><router-link class="sponsor-intro-link" to="/sanshubio">SanshuBio</router-link></h2>
      <p>
        Founded in 2014, Sanshu Biotechnology (Group) is located in the Shibei High-Tech Industrial Park, Nantong City, Jiangsu Province. Leveraging high-precision instrumentation to quantify life and harnessing big data analytics to decipher it, the company provides comprehensive technological solutions for research and development in the agricultural and medical sectors.
      </p>
      <p>
        The company has introduced a range of high-end precision equipment from world-renowned brands such as ABI, Thermo Fisher, AB SCIEX, Agilent, and Illumina. It has established a globally leading glycochemistry platform as well as a nationally leading platform for precise targeted analysis and multi-omics detection. Its business scope encompasses high-throughput sequencing, proteomics, metabolomics, precise targeted analysis, physicochemical testing, genetic transformation, starch and polysaccharide research, and molecular biology. This forms a comprehensive product and service system spanning from genes to proteins and from metabolism to phenotype. Through its innovative one-stop technological solutions, Sanshu has provided reliable and stable experimental data support to nearly two hundred research institutes and universities across China, serving diverse fields including medicine, botany, zoology, environmental science, food science, and soil science.
      </p>
      <p>
        Backed by substantial R&D investment and profound technological expertise, Sanshu Biotechnology is strategically expanding into the specialty starch-based new materials industry. It has established a full-industry-chain operational model covering gene editing, new variety breeding, cell factory construction, and the commercialization of starch-based industrial products, thereby forming a distinctive business ecosystem. The company has obtained ISO 9001 quality management system certification and CNAS laboratory accreditation, and has been honored with titles such as National Sci-Tech Small and Medium-sized Enterprise, High-tech Enterprise of Jiangsu Province, and Private Sci-Tech Enterprise of Jiangsu Province. Several members of its team have been selected for prestigious talent programs, including the Jiangsu Provincial Innovation and Entrepreneurship Talent Program, Nantong City's Zilang Yingcai Program, Jianghai Yingcai Program, as well as Nantong City's 333 High-Level Talent Training Project and 226 High-Level Talent Training Project.
      </p>
      <p>
        Adhering to the core values of Professionalism, Dedication, and Concentration, Sanshu Biotechnology upholds the conviction that technology should never hinder fundamental research or corporate R&D. The company is dedicated to becoming the most trusted technical partner for scientific researchers worldwide.
      </p>
    </div>

    <h1 @click="toggleSection(9)">Sponsorship Prospectus<el-icon style="float:right"><component :is="sections[9].visible ? ArrowDown : ArrowRight" /></el-icon></h1>
    <div v-show="sections[9].visible">
      <div class="img_box">
        <router-link to="/sponsorship">
            <img src="@/assets/images/ICTP2026_Sponsorship_page.png" alt="Sponsorship Prospectus" class="sponsorship-image" />
        </router-link>
      </div>
    </div>

    <!-- <h1 @click="toggleSection(8)">Conference Sponsorship Options<el-icon style="float:right"><component :is="sections[8].visible ? ArrowDown : ArrowRight" /></el-icon></h1>
    <div v-show="sections[8].visible">
      <h2>Diamond Sponsorship</h2>
      <p>Sponsorship fee of over 100,000 yuan, conference abstract book provides advertising pages, arranges conference presentations (product pitches) and audio-visual advertisements, TP conference official website provides product advertisement information. Provides a 15-20 square meter booth and poster space, waives conference fees for 2 people and provides meals during the conference; also provides 2 standard hotel rooms for 3 nights.</p>
      <h2>Gold Sponsorship</h2>
      <p>Sponsorship fee of 50,000 yuan, conference abstract book provides advertising pages. Arranges product pitches in breakout sessions, arranges audio-visual advertisements, provides a 10 square meter booth and poster space, waives conference fees and meal costs for 1 person, and provides 1 standard hotel room for 3 nights.</p>
      <h2>Silver Sponsorship:</h2>
      <p>Sponsorship fee of 30,000 yuan, provides an 8 square meter booth and poster space, waives conference fees and meal costs for 2 people.</p>
      <h2>Bronze Sponsorship</h2>
      <p>Sponsorship fee of 20,000 yuan, provides a 6 square meter booth and poster space, waives conference fees and meal costs for 1 person.</p>
      <h2>Contact us</h2>
      <p>Poster: Fei Chen, 18061284509</p>
    </div> -->

    <!-- <h1 @click="toggleSection(9)">Visitors<el-icon style="float:right"><component :is="sections[9].visible ? ArrowDown : ArrowRight" /></el-icon></h1>
    <div v-show="sections[9].visible">
      <component :is="'script'" type="text/javascript" src="//rf.revolvermaps.com/0/0/8.js?i=5buvod7hod6&amp;m=0&amp;c=ff0000&amp;cr1=ffffff&amp;f=arial&amp;l=33" async="async"></component>
    </div> -->
  </div>
</template>

<style scoped>
.conference-details {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  margin: 0 auto;
  padding: 20px;
  max-width: 66%;
}

h1 {
  background-color: rgb(233, 243, 246);
  padding: 10px;
  font-size: 2em;
  font-weight: bold;
  margin-top: 0.5em;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

h1:hover {
  background-color: rgb(218, 233, 239);
}

h1 .el-icon {
  font-size: 20px;
  color: #409eff;
  transition: transform 0.3s ease;
}

h2 {
  font-size: 1.5em;
  margin-top: 1.5em;
}

h3 {
  font-size: 1.2em;
  margin-top: 1em;
}

ul {
  list-style-type: disc;
  margin-left: 20px;
}

a {
  color: #1e90ff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.sponsor-intro-link {
  color: inherit;
  text-decoration: underline;
}

.photo_box {
  height: auto;
  padding: 16px 0;
}

.photo_box ul {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px 24px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.photo_li {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 120px;
  margin: 0;
  background: #ffffff;
  border: 1px solid #e6eef5;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.035);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.photo_li:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.06);
}

/* .photo_li img{
  position: relative;
  width: 100%;
  top: 50%;
  transform: translateY(-50%); 
} */

.photo_li img {
  max-width: 90%;
  max-height: 80%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}

@media (max-width: 768px) {
  .photo_li {
    width: 45vw;
    max-width: 240px;
  }
}

@media (max-width: 480px) {
  .photo_li {
    width: 80vw;
  }
}

.img_box {
    margin-top: 20px;
    width:100%;
    cursor: pointer;
}

.img_box img {
  width:100%;
}
</style>


